import React, { useState, useEffect } from 'react';
import { API_URL } from '../../config';

const TopAlert = () => {
  const [alertText, setAlertText] = useState('');

  useEffect(() => {
    fetch(`${API_URL}/topalert/listlast`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          setAlertText(data.data[0].text);
        }
      })
      .catch((error) => console.error(error));
  }, []);

  return (
    <div style={{ backgroundColor: '#EAB22D', padding: '10px' }}>
      <p style={{ textAlign: 'center' }}>
        {alertText.split(' ').map((word, index) => {
          if (word.startsWith('http')) {
            return (
              <a
                href={word}
                target="_blank"
                rel="noreferrer"
                style={{ fontSize: 'smaller', color: '#222E50' }}
              >
                {word}
              </a>
            );
          }
          return `${word} `;
        })}
      </p>
    </div>
  );
};

export default TopAlert;
